module.exports = __webpack_public_path__ + "img/es.esab57bf7.svg";